import { ATTRIBUTION_MODEL_TO_SNAKE_MAP, CROSS_CHANNEL_REQUIRED_FILTERS } from "./api";
import { ATTRIBUTION_MODEL_FIELDS } from "./configuration";
/**
 * The wire contract for the looker-gateway delivery query endpoints
 * (`POST /looker/v1/query/delivery{,/filter-options}`).
 *
 * Delivery reads the same explore as cross-channel attribution
 * (`explore_conversion`) — same snake_case naming, restricted to impression-side
 * fields — but not the same filters: `pixel_type`, `beacon_ids`, and
 * `use_expanded_table` are excluded, since delivery has no attribution/conversion
 * output to scope by pixel.
 * See `services/looker-gateway/docs/delivery-query-api.md`.
 */
/** VIDEO/AUDIO/DISPLAY — not imported: looker-gateway's CROSS_CHANNEL_REPORT_TYPES lives downstream of mad-sdk. */
const DIGITAL_REPORT_TYPES = ["VIDEO", "AUDIO", "DISPLAY"];
/**
 * A field is delivery's if it's valid for a digital report type and,
 * per its kind, delivery-level: `metricSource === "impression"` for a metric,
 * or not beacon/conversion/Universal-Pixel/footfall-scoped for a dimension.
 */
const isDeliveryField = (field) => {
    const config = ATTRIBUTION_MODEL_FIELDS[field];
    if (!config.reportTypes.some((type) => DIGITAL_REPORT_TYPES.includes(type))) {
        return false;
    }
    return config.type === "metric"
        ? config.metricSource === "impression"
        : !config.isBeaconField &&
            !config.isConversionField &&
            !config.isUniversalPixelField &&
            !config.isFootfallField;
};
/**
 * Every `AttributionModel` field the delivery endpoint may return. Derived
 * rather than hand-listed, so a newly added impression metric or non-beacon/
 * Universal-Pixel/footfall dimension lands on the endpoint automatically
 * instead of silently going missing.
 */
export const DELIVERY_MODEL_FIELDS = Object.keys(ATTRIBUTION_MODEL_FIELDS).filter(isDeliveryField);
/** Every delivery field name, in `DELIVERY_MODEL_FIELDS` order. */
export const ALL_DELIVERY_FIELD_NAMES = DELIVERY_MODEL_FIELDS.map((field) => ATTRIBUTION_MODEL_TO_SNAKE_MAP[field]);
export const DELIVERY_REQUIRED_FILTERS = CROSS_CHANNEL_REQUIRED_FILTERS;
//# sourceMappingURL=delivery.js.map